import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import toast from "react-hot-toast";
import "./style.css";
import { unsubscribeGuest } from "../../redux/event";
import Loader from "../loader";

const unsubscribeImg =
	"https://assets.esstart.com/common/unsubscribe-image.png";

export const Unsubscribe = () => {
	const [searchParams] = useSearchParams();
	const dispatch: any = useDispatch();
	const email = searchParams.get("email") || "";
	const tenantName = searchParams.get("tenantName") || "";

	const [loading, setLoading] = useState(false);
	const [unsubscribed, setUnsubscribed] = useState(false);
	const [stayed, setStayed] = useState(false);

	const onStay = () => {
		setStayed(true);
	};

	const onUnsubscribe = async () => {
		setLoading(true);
		const res: any = await dispatch(unsubscribeGuest({ email, tenantName }));
		setLoading(false);
		if (unsubscribeGuest.fulfilled.match(res)) {
			setUnsubscribed(true);
			toast("You have been unsubscribed successfully!", {
				className: "success-toast",
			});
		} else {
			toast("Something went wrong, please try again!", {
				className: "alert-toast",
			});
		}
	};

	return (
		<div className='unsubscribe_page'>
			<div className='unsubscribe_container'>
				{!stayed && (
					<div className='unsubscribe_image'>
						<img src={unsubscribeImg} alt='Unsubscribe' />
					</div>
				)}

				{loading ? (
					<Loader />
				) : unsubscribed ? (
					<>
						<p className='unsubscribe_heading'>You've been unsubscribed</p>
						<p className='unsubscribe_subtext'>
							You won't receive emails from us anymore.
						</p>
					</>
				) : stayed ? (
					<>
						<p className='unsubscribe_heading'>
							Thanks for sticking around! 🎉
						</p>
						<p className='unsubscribe_subtext'>
							We'll keep sending you the good stuff.
						</p>
					</>
				) : (
					<>
						<p className='unsubscribe_heading'>
							Are you sure about unsubscribing?
						</p>
						<p className='unsubscribe_subtext'>
							If you unsubscribe now, you might miss nice deals and useful hints
							from us!
						</p>
						<div className='unsubscribe_buttons'>
							<button className='unsubscribe-stay-btn' onClick={onStay}>
								I'd rather stay
							</button>
							<button className='unsubscribe-me-btn' onClick={onUnsubscribe}>
								Unsubscribe me &#8594;
							</button>
						</div>
					</>
				)}
			</div>
		</div>
	);
};
